import Grid from '@mui/material/Grid';

function Row({ ...others }) {
  return <Grid container spacing={3} {...others} />;
}

Row.propTypes = {
  ...Grid.propTypes,
};

export default Row;
